export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./jackpots.vue?vue&type=template&id=a3014cae"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/jackpots.vue?vue&type=template&id=a3014cae
// module id = cU7f
// module chunks = 0